module.exports = __webpack_public_path__ + "img/undraw_User_flow_re_bvfx.a4880972.svg";